import React, { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useResultContext } from '../context/ResultContextProvider';
import Links from './Links';

const Search = () => {
  const [text, setText] = useState('Elon Musk');
  const { setSearchTerm } = useResultContext();
  const [debouncedValue] = useDebounce(text, 300);
  useEffect(() => {
    if (debouncedValue) setSearchTerm(debouncedValue);
  }, [debouncedValue]);
  return (
    <div className='relative sm:ml-48 md:ml-72 sm:-mt-10 mt-3'>
      <input
        className='focus:outline-none sm:w-96 w-80 h-10 dark:bg-200 border rounded-full shadow-sm text-black hover:shadow-lg items-center p-6'
        type='text'
        value={text}
        onChange={e => setText(e.target.value)}
      />
      {debouncedValue && (
        <button
          className='top-3 right-4 absolute cursor-pointer'
          type='button'
          onClick={() => setText('')}
        >
          {' '}
          X
        </button>
      )}
      <Links />
    </div>
  );
};

export default Search;
